export default (() => {
    if (!global || !global._babelPolyfill) {
        require('babel-polyfill')
    }
})()


// WEBPACK FOOTER //
// ./src/helpers/maybe-polyfill.js